import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  const flexCenter = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  return {
    avatar: {
      width: '60px',
      height: '60px',
      marginBottom: '6px',
    },
    dropdownBox: {
      width: '300px',
    },
    blueBox: {
      ...flexCenter,
      flexDirection: 'column',
      backgroundColor: legacyColors.blue,
      padding: '10px 5px 15px 5px',
    },
    userNameBox: {
      ...flexCenter,
      flexDirection: 'column',
      color: legacyColors.white,
    },
    whiteBox: {
      ...flexCenter,
      backgroundColor: legacyColors.white,
      flexWrap: 'wrap',
    },
    text: {
      fontSize: '11px',
    },
    nameTitle: {
      fontSize: '14px',
    },
  };
};
